/**
 * OTP 검증 실패 에러
 * OTP 코드가 잘못되었을 때 발생
 */
export default class OtpVerificationError extends Error {
  public code: string
  public statusCode: number

  constructor(message: string = 'Invalid verification code') {
    super(message)
    this.name = 'OtpVerificationError'
    this.code = 'UNAUTHORIZED'
    this.statusCode = 401
  }
}
